import { eachDayOfInterval, endOfWeek, startOfWeek } from 'date-fns'

export function getCalendarWeek(day: Date) {
  return eachDayOfInterval({
    start: startOfWeek(day, { weekStartsOn: 1 }),
    end: endOfWeek(day, { weekStartsOn: 1 }),
  })
}
